import * as React from "react"

import Layout from "../../components/Layout"
import BlogRoll from "../../components/BlogRoll"
import teamworkImg from "../../img/illustration-teamwork.svg"
import Tags from "../../components/Tags"
import PageHead from "../../components/PageHead"
import usePosts from "../../hooks/usePosts"

const blogDescription =
  "Your resource for best practices and the latest insights relating to people analytics, employee listening and performance management"

const tagDescriptions = {
  "The Teamspective Solution":
    "Teamspective helps companies timely identify and tackle their most important issues in teamwork, leadership, and cross-team collaboration. Learn more about our solutions in the latest blog posts.",
  "Employee Engagement":
    "Discover Teamspective's best practices and the latest insights relating to employee listening and engagement.",
  "Feedback and Performance":
    "Discover Teamspective's best practices and the latest insights relating to individual and team development, feedback culture, and continuous learning.",
  "Organizational Network Analysis":
    "Discover Teamspective's best practices and the latest insights relating to network analysis and organizational design.",
}

const capitalize = (str) =>
  str
    .split(" ")
    .map((word) => word[0].toUpperCase() + word.substring(1))
    .join(" ")

export const Head = ({ location }) => {
  const match = location.pathname.match(/\/tags\/(\S+)\//)
  const tag = match ? capitalize(match[1].replace("-", " ")) : null
  return (
    <PageHead
      title={tag ? `The Teamspective Blog – ${tag}` : "The Teamspective Blog"}
      description={tag ? tagDescriptions[tag] : blogDescription}
    />
  )
}

export const BlogIndexTemplate = ({ posts, tags }) => {
  const tag = tags.length === 1 ? tags[0] : null
  return (
    <Layout>
      <div className="spacing-xl blog-page-head">
        <div>
          <h1 className="h2">{tag ? tag : "The Teamspective Blog"}</h1>
          <p>{tag ? tagDescriptions[tag] : blogDescription}</p>
          {!tag && <Tags tags={tags} />}
        </div>
        <img src={teamworkImg} />
      </div>
      <div className="content">
        <h4>Articles</h4>
        <BlogRoll posts={posts} />
      </div>
    </Layout>
  )
}

const BlogIndexPage = () => {
  const { posts, tags } = usePosts()
  return <BlogIndexTemplate posts={posts} tags={tags} />
}

export default BlogIndexPage
